import { bus } from "@/main";

export default {
	data() {
		return{
			headerOpen: false,
			routeName: this.$route.name,
			language: this.$route.params.lang,
			isLoading: true
		}
	},
	props: [
		"title",
		"slug",
		"name",
		"content",
		"small",
		"black",
	],
	created() {
		window.addEventListener("scroll", () => {
			let scroll = window.pageYOffset;
			let element = this.$el

			if (scroll > element.offsetTop && this.routeName == this.name) {
				this.headerOpen = true
			} else {
				this.headerOpen = false
			}
		});
		bus.$on( this.slug + 'IsReady', () => {
			this.isLoading = false;
			setTimeout(() => {
				this.scrollTop();
			}, 500);
		})
	},
	computed: {
		getSlug() {
			return this.translate(this.slug)
		},
	},
	watch: {
		"$route": function () {
			this.routeName = this.$route.name
			this.language = this.$route.params.lang
		},
	},
	methods: {
		evalRoute(value) {
			if (value == this.$route.path)
				return true
			else
				return false
		},
		scrollTop() {
			let scroll = this.$el.offsetTop + 2
			
			setTimeout(() => {
				window.scroll({
					top: scroll,
					left: 0,
					behavior: 'smooth'
				});
			}, 10);
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/paper-block/paper.block.js